import { render, staticRenderFns } from "./WxpayPayConfig.vue?vue&type=template&id=1f1f304a&scoped=true"
import script from "./WxpayPayConfig.vue?vue&type=script&lang=js"
export * from "./WxpayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f304a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1f304a')) {
      api.createRecord('1f1f304a', component.options)
    } else {
      api.reload('1f1f304a', component.options)
    }
    module.hot.accept("./WxpayPayConfig.vue?vue&type=template&id=1f1f304a&scoped=true", function () {
      api.rerender('1f1f304a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/custom/WxpayPayConfig.vue"
export default component.exports